import { render, staticRenderFns } from "./overview-list.vue?vue&type=template&id=3d97bda0&scoped=true"
import script from "./overview-list.vue?vue&type=script&lang=js"
export * from "./overview-list.vue?vue&type=script&lang=js"
import style0 from "./overview-list.vue?vue&type=style&index=0&id=3d97bda0&prod&lang=scss&scoped=true"
import style1 from "./overview-list.vue?vue&type=style&index=1&id=3d97bda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97bda0",
  null
  
)

export default component.exports